function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#ffffff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 12C22 17.5229 17.5228 22 12 22C6.47715 22 2 17.5229 2 12C2 6.47718 6.47715 2.00003 12 2.00003C17.5228 2.00003 22 6.47718 22 12ZM14.0837 9.0967C13.8495 8.09 12.8898 7.41771 11.8534 7.53436C10.8171 7.65101 10.0341 8.51944 10.0339 9.55252C10.0338 9.92656 9.72766 10.2297 9.35003 10.2296C8.97239 10.2296 8.66632 9.9263 8.6664 9.55226C8.66673 7.83038 9.97168 6.38294 11.699 6.18852C13.4263 5.99411 15.0259 7.11463 15.4163 8.79253C15.8067 10.4704 14.8635 12.1713 13.2245 12.7453C12.9512 12.841 12.7686 13.097 12.7688 13.3841V13.6156C12.7688 13.9896 12.4626 14.2928 12.085 14.2928C11.7074 14.2928 11.4012 13.9896 11.4012 13.6156V13.3848C11.4009 12.5236 11.9489 11.7554 12.7687 11.4683C13.7521 11.1239 14.3179 10.1034 14.0837 9.0967ZM12.0847 15.9445C11.5183 15.9445 11.0591 16.3993 11.0591 16.9604C11.0591 17.5214 11.5183 17.9762 12.0847 17.9762C12.6512 17.9762 13.1103 17.5214 13.1103 16.9604C13.1103 16.3993 12.6512 15.9445 12.0847 15.9445Z",
  fill: "#0A0806"
});

const SvgQuestionFill = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuestionFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/question-fill.cf34b951.svg";
export { ForwardRef as ReactComponent };